export default [
  {
    description:
      'GOOD NEWS FOR SOCIAL ENTREPRENEURS AND STARTUPS IN INDONESIA! In collaboration with KOICA, instellar is looking for potential startups, innovative businesse, and social enterprises in Indonesia which working to solve environmental-related challenge in Indonesia with innovative business models.',
    title: 'Sekilas Mengenai Kingsejong',
    media: ['https://i.imgur.com/gupoRY0.mp4']
  }
]
